import React, { useEffect } from "react";

const LegacyAvatarChangeBannerStyleModifier = () => {
    useEffect(() => {
        document.body.classList.add("avatar-settings-page");
    }, []);

    return null;
};

export default LegacyAvatarChangeBannerStyleModifier;
